import { gql } from "@apollo/client";

const GET_SHIPMENT_DOCUMENT_UPLOAD_URLS = gql`
  query GetShipmentDocumentUploadUrls($shipmentId: Int!, $filenames: [String]!) {
    getShipmentDocumentUploadUrls(shipmentId: $shipmentId, filenames: $filenames) {
      success
      error
      urls {
        url
        key
        filename
      }
    }
  }
`;

const DELETE_SHIPMENT_DOCUMENT = gql`
  mutation DeleteShipmentDocument($input: DeleteShipmentDocumentInput!) {
    deleteShipmentDocument(input: $input) {
      success
      error
    }
  }
`;

export { GET_SHIPMENT_DOCUMENT_UPLOAD_URLS, DELETE_SHIPMENT_DOCUMENT };
